import { type ComponentType } from 'react'
import {
	Box,
	Stack,
	StackProps,
	type BoxProps,
} from '@mui/material'
import { styled } from '@mui/material/styles'

export const PageWrapper: ComponentType<BoxProps> = styled( Box )<BoxProps>( ( { theme } ) => ( {
	margin: theme.spacing( 4, 6 ),
	minHeight: `calc(100vh - ${theme.spacing( 8 )})`,
	[ theme.breakpoints.down( 'sm' ) ]: {
		margin: theme.spacing( 2, 3 ),
	},
} ) )

export const PageSection: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	marginBottom: theme.spacing( 4 ),
} ) )
